(function () {
    'use strict';

    angular
        .module('app.topicSettingReportSegment')
        .controller('topicSettingReportSegmentCtrl', ['$scope', '$modal', '$http', '$rootScope', '$modalInstance', 'topicSettingReportSegmentService', 'selectedTopic',
            function ($scope, $modal, $http, $rootScope, $modalInstance, topicSettingReportSegmentService, selectedTopic)
            {
                $scope.selectedTopic = selectedTopic;
                $scope.tempSelectedTopic = []

                $scope.getTopics = function ()
                {
                    var result = null;
                    topicSettingReportSegmentService.getListTopic()
                        .then(function(result){
                            $scope.topics = result.data;
                            angular.forEach($scope.selectedTopic, function(item) {
                               angular.forEach($scope.topics, function(topic) {
                                    if(topic.id == item.topic_id)
                                    {
                                        topic.checked = true;
                                        $scope.tempSelectedTopic.push({
                                            topic_id: topic.id,
                                            topic_name: topic.name
                                        });
                                    }
                                })
                            })
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                    });
                }

                $scope.getTopics();


                $scope.selectTopic = function(topic)
                {
                    $scope.isExist = false;
                    if($scope.selectedTopic.length == 0)
                    {
                        $scope.selectedTopic.push({
                            topic_id: topic.id,
                            topic_name: topic.name
                        });
                        topic.checked = true;
                    }
                    else
                    {
                        for(var i = $scope.selectedTopic.length - 1; i >= 0; i--)
                        {
                            if($scope.selectedTopic[i].topic_id == topic.id)
                            {
                                $scope.isExist = true;
                                $scope.selectedTopic.splice(i, 1);
                                topic.checked = false;
                            }
                        }
                        if($scope.isExist == false)
                        {
                            $scope.selectedTopic.push({
                                topic_id: topic.id,
                                topic_name: topic.name
                            });
                           topic.checked = true;
                        }
                    }
                }

                $scope.saveSetting = function()
                {
                    $modalInstance.close($scope.selectedTopic);
                }

                $scope.closeModal = function()
                {
                    $modalInstance.dismiss($scope.tempSelectedTopic);
                }

            }
        ]);
})();
